<template>
  <div>
    <el-form
      ref="form"
      size="small"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      label-position="top"
    >
      <el-row :gutter="10">
        <el-col :span="24">
          <div class="mb-1">
            <b-badge
              style="font-size: 12px"
              :variant="
                formData.inputStandardStatus === 'Y'
                  ? 'success'
                  : formData.inputStandardStatus === 'N'
                  ? 'danger'
                  : 'primary'
              "
            >
              {{
                formData.v_inputStandardStatus
                  ? formData.v_inputStandardStatus
                  : '--'
              }}
            </b-badge>
            <el-divider direction="vertical"></el-divider>
            <span style="font-size: 14px; color: #606266">
              Update：{{ formData.modifyByName ? formData.modifyByName : '--' }}
              at
              {{ formData.modifyDate ? formData.modifyDate : '--' }}
            </span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_categoryCode') || '产品分类'"
            prop="categoryCode"
          >
            <category-cascader
              :masterCategoryCode.sync="formData.masterCategoryCode"
              :detailCategoryCode.sync="formData.categoryCode"
              :params="categoryParams"
              clearable
              size="small"
            ></category-cascader>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_materialInfo') || '材料信息（中文）填写要求'"
          >
            <el-input
              clearable
              v-model="formData.materialInfo"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              type="textarea"
              rows="12"
              size="small"
              show-word-limit
              maxlength="500"
            />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
            :label="
              $l('form_label_materialInfoEn') || '材料信息（英文）填写要求'
            "
          >
            <el-input
              clearable
              v-model="formData.materialInfoEn"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              type="textarea"
              rows="12"
              size="small"
              maxlength="500"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    inputStandardCode: String,
    params: { type: Object, default: () => {} },
  },
  data() {
    return {
      formData: {},
      productLine: 'ABSHome',
      rules: {
        categoryCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'blur',
          },
        ],
        isSquareMeter: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  computed: {
    categoryParams() {
      return { parentCode: this.productLine }
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.inputStandardCode) return

      this.$api
        .masterGoodsInputStandardDetailApi({
          inputStandardCode: this.inputStandardCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }
      this.loadingOpen()
      this.$api
        .masterGoodsInputStandardSaveApi(this.formData)
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.openQuestion()
    },
    close() {
      this.$emit('close')
    },
    openQuestion() {
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存',
        }
      )
        .then(() => {
          this.save()
        })
        .catch((action) => {
          if (action === 'cancel') {
            this.close()
          }
        })
    },
  },
}
</script>
